<template>
    <div id="sql" class="mt">
        <a-row type="flex" justify="start">
            <a-col :span="7" style="border-right: 1px solid #efefef;padding-right: 4px;">
                <a-row type="flex" justify="start">
                    <a-col>
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('generic.Add') }}</span>
                            </template>
                            <img @click="addTml" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
                        </a-tooltip>
                        <a-popconfirm
                                :title="$t('generic.AreyoudeleTask')"
                                @confirm="delTml"
                                :okText="$t('generic.Yes')"
                                :cancelText="$t('generic.No')">
                            <a-tooltip placement="topLeft" class="ml4">
                                <template slot="title">
                                    <span>{{ $t('generic.Delete') }}</span>
                                </template>
                                <img class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                            </a-tooltip>
                        </a-popconfirm>

                    </a-col>
                </a-row>
                <a-row class="mt4">
                    <vxe-table
                            border
                            resizable
                            class="mytable-style"
                            ref="dataTmlTable"
                            highlight-hover-row
                            :cell-class-name="cellClassName"
                            @cell-click="dbcellClickEvent"
                            size="mini"
                            :data="tableData">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="templateName" title="Template Name" minWidth="150"></vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-col>
            <a-col :span="16" class="ml4"  v-if="tableData.length > 0">
                <a-tabs default-active-key="1">
                    <a-tab-pane key="1" tab="Template">
                        <template-coms :dataSourceRow="dataSourceRow" :headerUid="headerUid" v-on:emitTmlEdit="getEmitTmlEdit"></template-coms>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="Data Source">
                        <data-source :dataSourceRow="dataSourceRow" :headerUid="headerUid" ></data-source>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="File">
                        <upload-image :dataSourceRow="dataSourceRow" :headerUid="headerUid"></upload-image>
                    </a-tab-pane>
                </a-tabs>
            </a-col>
        </a-row>
        <a-modal
                title="Add Template"
                :visible="addTmlVis"
                width="45%"
                @cancel="() => (addTmlVis = !addTmlVis)"
        >
            <template slot="footer">
                <a-button type="primary" size="small" @click="addSaveTml">Save</a-button>
            </template>
            <a-form :form="addTmlForm">
                <a-form-item label="Template Name" v-bind="formItemLayout">
                    <a-input
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            style="width: 100%;"
                            v-decorator="[
                              'templateName',
                              {
                                rules: [{ required: true, message: $t('publicLang.Required')}]
                              }
                            ]"
                    />
                </a-form-item>
                <a-form-item label="Data Source" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            size="small"
                            v-decorator="[
                              'rtSqlUid',

                              { initialValue: tmlDataSourceList.length == 1 ? tmlDataSourceList[0].uid: null,
                                 rules: [{ required: true, message: $t('publicLang.Required')}]
                              }
                            ]"
                    >
                        <a-select-option v-for="item in tmlDataSourceList" :value="item.uid">{{item.dsName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Remark" v-bind="formItemLayout">
                    <a-textarea
                        :rows="4"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        size="small"
                        style="width: 100%;"
                        v-decorator="[
                      'remark',
                    ]"/>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import dataSource from './manager/dataSource.vue'
    import templateComs from './manager/templateComs.vue'
    import uploadImage from './manager/uploadImage.vue'
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        components:{
            dataSource,
            templateComs,
            uploadImage
        },
        props:{
            headerUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        data(){
            return{
                addTmlForm:this.$form.createForm(this),
                addTmlVis: false,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                tableData: [],
                tmlDataSourceList: [],
                dataSourceRow: {},
                dataSourceUid: ''
            }
        },
        watch:{
            headerUid(v){
                this.dataTmlTable()
            }
        },
        created(){
            this.dataTmlTable()
        },
        methods:{
            getEmitTmlEdit(v){
                ajax.get(api.REPORTGENERICCONFIGTML,{rtMasterUid: this.headerUid}).then(res=>{
                    if(res.code == 200){
                        this.tableData = res.data
                        this.dataSourceRow = v
                        this.dataSourceUid = v.uid
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
//            tml table 相关 add 获取data 数据
            dataTmlTable(){
                ajax.get(api.REPORTGENERICCONFIGTML,{rtMasterUid: this.headerUid}).then(res=>{
                    if(res.code == 200){
                        this.tableData = res.data
                        if(this.tableData.length > 0){
                            this.dataSourceRow = this.tableData[0]
                            this.dataSourceUid = this.tableData[0].uid
                        }
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            addTml(){
                this.addTmlVis = true
                ajax.get(api.REPORTGENERICCONFIGDATASOURCE,{rtMasterUid: this.headerUid}).then(res=>{
                    this.tmlDataSourceList = res.data
                })
                this.addTmlForm.resetFields();
            },
            addSaveTml(){
                this.addTmlForm.validateFields((error, values)=>{
                    if(!error){
                        let params = values
                        params.rtMasterUid = this.headerUid
                        ajax.post(api.REPORTGENERICCONFIGIREPORT,params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.dataTmlTable()
                                this.addTmlVis = false
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },
            delTml(){
                let arr = this.$refs.dataTmlTable.getCheckboxRecords()
                if(arr.length > 0){
                    let params = {uids: []}
                    for(let i in arr){params.uids.push(arr[i].uid)}
                    ajax.post(api.REPORTGENERICDELCONFIGIREPORT,params).then(res=>{
                        if(res.code == 200){
                            this.dataTmlTable()
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'))
                }
            },
            //            双击当前行变色
            cellClassName({ row }) {
                if (row ===  this.dataSourceRow ) {
                    return "col-orange";
                }
            },
            dbcellClickEvent({ row }){
                this.dataSourceRow = row
                this.dataSourceUid = row.uid
            },
        }
    }
</script>
<style>
    .mytable-style .vxe-body--column.col-orange {
        background-color: #8fbc8f;
        color: #fff;
    }
</style>